// Library methods

// Utils
import { POST, GET } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_FETCH_NOTIFICATION_EVENTS,
    API_FETCH_COMM_PROFILE,
    API_ADD_COMM_PROFILE,
    API_UPDATE_COMM_PROFILE,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as commProfileActions from './commProfile.actions';

// Constants
import {
    FETCH_NOTIFICATION_EVENT_REQUEST,
    FETCH_COMM_PROFILE_REQUEST,
    ADD_COMM_PROFILE_REQUEST,
    UPDATE_COMM_PROFILE_REQUEST,
} from './commProfile.constants';
import { takeLatest, put, call } from 'redux-saga/effects';

export function* fetchNotificationEvents() {
    yield put(loaderActions.showLoader());
    try {
        const { data } = yield call(GET, API_FETCH_NOTIFICATION_EVENTS);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                commProfileActions.fetchNotificationEventSuccess(
                    data.eventsList
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                commProfileActions.fetchNotificationEventError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            commProfileActions.fetchNotificationEventError({ error: data })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchCommProfile() {
    yield put(commProfileActions.showLoader());
    try {
        const { data } = yield call(GET, API_FETCH_COMM_PROFILE);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(commProfileActions.fetchCommProfileSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                commProfileActions.fetchCommProfileError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(commProfileActions.fetchCommProfileError({ error: data }));
    }
    yield put(commProfileActions.hideLoader());
}

export function* addCommProfile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_ADD_COMM_PROFILE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(commProfileActions.addCommProfileSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                commProfileActions.addCommProfileError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(commProfileActions.addCommProfileError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* updateCommProfile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_UPDATE_COMM_PROFILE, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(commProfileActions.updateCommProfileSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                commProfileActions.updateCommProfileError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(commProfileActions.updateCommProfileError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* commProfileSaga() {
    yield takeLatest(FETCH_NOTIFICATION_EVENT_REQUEST, fetchNotificationEvents);
    yield takeLatest(FETCH_COMM_PROFILE_REQUEST, fetchCommProfile);
    yield takeLatest(ADD_COMM_PROFILE_REQUEST, addCommProfile);
    yield takeLatest(UPDATE_COMM_PROFILE_REQUEST, updateCommProfile);
}
